import ApiService from './api';
import type { AxiosResponse } from 'axios';

const IntegrationService = {
  /**
   * Fetches all integration types from the CMS.
   * @param locale UI language the CMS texts should be returned in (default 'de')
   * @returns Integration type entries; empty array on error
   */
  getAllTypes: async function(locale: string = 'de'): Promise<any[]> {
    try {
      const response = await ApiService.get(
        `/schaltzentrale/cms/integrations/${locale}`
      );
      return response.data;
    } catch (e) {
      return [];
    }
  },
  /**
   * Sends a test payload to the bot's configured webhook integration.
   * @param botId ID of the bot
   * @param body The test payload to POST to the webhook
   * @returns The full axios response, or false on error
   */
  testWebhook: async function(botId: string, body: any): Promise<AxiosResponse | false> {
    try {
      const response = await ApiService.post(
        `/schaltzentrale/integrations/webhook/${botId}/`,
        body
      );

      return response;
    } catch (e) {
      return false;
    }
  },
};

export default IntegrationService;

export { IntegrationService };
